/**
 * SOLID Review
 * S — Strong. One concern: structural equality of two JSON values.
 * O — Strong. Any JSON; nothing here names a shape.
 * L — N/A — a function.
 * I — Strong. One function.
 * D — Strong. Nothing: shared/ is the dependency-free kernel every layer may import.
 */

/**
 * Structural equality over JSON values (frontend strict-ports plan, FE1). Shared because two layers ask
 * the same question of the same values. The Domain asks which table fields a decision changed; the
 * store's port asks whether the derived values it is handed are the ones it already holds, so
 * `useSyncExternalStore` readers keep the same reference and do not re-render.
 */
export function sameJson(a: unknown, b: unknown): boolean {
  if (a === b) return true;
  if (a === null || b === null || typeof a !== 'object' || typeof b !== 'object') return false;
  if (Array.isArray(a) || Array.isArray(b)) {
    if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;
    return a.every((v, i) => sameJson(v, b[i]));
  }
  const ra = a as Record<string, unknown>;
  const rb = b as Record<string, unknown>;
  const keys = Object.keys(ra);
  return keys.length === Object.keys(rb).length && keys.every((k) => Object.prototype.hasOwnProperty.call(rb, k) && sameJson(ra[k], rb[k]));
}
